import(/* webpackMode: "eager", webpackExports: ["Cookies"] */ "/tebuto/webapp/app/landing/(main)/datenschutzerklaerung/Cookies.tsx");
